import ProductDetail, {
    updateAddToCartEnableDisableOtherElements,
} from '@assets/product/detail';
import { createCustomDropdown } from '../components/customSelect';

export default class Detail extends ProductDetail {
    init() {
        super.init();
        this.createSizeDropdown($('#custom-select-sizes .custom-select select'));
        $('body').on(
            'product:afterAttributeSelect',
            (event, data) => {
                this.createSizeDropdown(data.container.find('#custom-select-sizes .custom-select select'));
            },
        );
    }

    createSizeDropdown($select) {
        if (!$select.length) return;
        createCustomDropdown($select);
    }

    updateAddToCart() {
        $('body').on('product:updateAddToCart', (e, response) => {
            // update local add to cart (for sets)
            let disablingCondition = !response.product.readyToOrder
            || !response.product.available
            || !!response.product.disabled;
            if ($('button.add-to-cart.trigger-size-selector').length) {
                disablingCondition = (response.product.readyToOrder && (!response.product.available || !!response.product.disabled));
            }
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                disablingCondition,
            );
            const enable = $('.product-availability')
                .toArray()
                .every(
                    (item) => $(item).data('available')
                    && $(item).data('ready-to-order'),
                );
            updateAddToCartEnableDisableOtherElements(!enable);
            if (window.SitePreferences.backinstock?.enableBackInStock) {
                const notifyMeCondition = ((!!response.product.disabled || !response.product.available) && !!response.product.readyToOrder);
                const $cartButtonWrapper = $('.cart-and-ipay:has(".back-in-stock-btn"):has(".add-to-cart")');
                $cartButtonWrapper.toggleClass('backorder-product', notifyMeCondition);
            }
        });
    }
}
